import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { GlobalVariable } from '../helpers/settings';
import { UserService } from './user.service';
import { Subscription } from '../models/subscription';
import { RefreshVerificationService } from './refresh-verification.service';

export interface PaginationData {
	docs: any[];
	total: number;
	limit: number;
	page: number;
	pages: number;
}

@Injectable({
	providedIn: 'root'
})
export class SubscriptionService {
	readonly BASE_URL = `${GlobalVariable.server.host}/subscriptions`;

	constructor(
		private httpClient: HttpClient,
		private userService: UserService,
		private refreshVerifService: RefreshVerificationService
	) {}

	find(params: any): Observable<Subscription[]> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Subscription[]>(`${this.BASE_URL}/find`, params)
		);
	}

	findSubscriptionsByPayment(params: any): Observable<Subscription[]> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Subscription[]>(`${this.BASE_URL}/find-subscriptions-by-payment`, params)
		);
	}

	findSubscriptionsByUser(params: any): Observable<Subscription[]> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Subscription[]>(`${this.BASE_URL}/find-subscriptions-by-user`, params)
		);
	}

	findById(id: string): Observable<Subscription> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<Subscription>(`${this.BASE_URL}/find-by-id/${id}`)
		);
	}

	edit(id: string, data: Subscription): Observable<{ isUpdated: Boolean; message: string }> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<{ isUpdated: Boolean; message: string }>(`${this.BASE_URL}/edit/${id}`, {
				data,
				subscriptionId: id
			})
		);
	}

	getCurrentSubscription(): Observable<Subscription> {
		return this.userService
			.findById(
				this.userService.getCurrentUser()._id,
				false,
				true,
				false,
				null,
				null,
				'subscription',
				null,
				'findById'
			)
			.pipe(
				switchMap(user => {
					const subscription = user?.subscription;
					const subsId = subscription?.['_id'] || subscription;
					return this.findById(subsId);
				})
			);
	}

	activateApplication(params: {
		code: string;
		isActive: boolean;
	}): Observable<{ isActive: Boolean; applications: string[] }> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<{ isActive: Boolean; applications: string[] }>(
				`${this.BASE_URL}/application/activate`,
				params
			)
		);
	}
}
